import { deleteWithPayload, deleteRequest, get, post, put } from "../../../shared/data";
import { getSortParams, getFilterParams } from "../../../shared/helpers";
import { filterConfig } from "./constants";

export const getRole = (roleId) => {
    return get(`/roles/${roleId}`);
};

export const getRoles = (pageNumber = 1, pageSize = 100, sort = [], filter = []) => {
    const sortBy = getSortParams(sort);
    const filterBy = getFilterParams(filter, filterConfig);

    return get(`/roles?pagesize=${pageSize}&pagenumber=${pageNumber}${sortBy}${filterBy}`);
};

export const addRole = (name, description) => {
    const payload = {
        name,
        description,
    };

    return post(`/roles`, payload);
};

export const deleteRole = (roleId) => {
    return deleteRequest(`/roles/${roleId}`);
};

export const getRolePermissions = (roleId, pageNumber = 1, pageSize = 100, sort = [], filter = []) => {
    const sortBy = getSortParams(sort);
    const filterBy = getFilterParams(filter);

    return get(`/roles/${roleId}/permissions?pagesize=${pageSize}&pagenumber=${pageNumber}${sortBy}${filterBy}`);
};

export const addPermissionToRole = (roleId, name) => {
    const payload = [
        {
            name,
        },
    ];

    return post(`/roles/${roleId}/permissions`, payload);
};

export const deletePermissionFromRole = (roleId, name) => {
    const payload = [{ name }];

    return deleteWithPayload(`/roles/${roleId}/permissions`, payload);
};

export const getPermissions = (pageNumber = 1, pageSize = 100) => {
    return get(`/permissions?pagesize=${pageSize}&pagenumber=${pageNumber}`);
};

export const addPermissions = (name, description) => {
    const payload = [
        {
            name,
            description,
        },
    ];

    return post(`/permissions`, payload);
};

export const deletePermissions = (name, description) => {
    const payload = [
        {
            name,
            description,
        },
    ];

    return post(`/permissions`, payload);
};

export const assignUserRolesAndTeams = (userId, payload) => {
    const settings = { noRedirect: true };

    return put(`/users/${userId}`, payload, settings );
};
